import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import AppBar from "@mui/material/AppBar";
import MUITabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
const useStyles = makeStyles(theme => ({
  tabsRoot: {
    fontFamily: theme.typography.fontFamily,
    backgroundColor: theme.background.paper,
    boxShadow: "unset",
    border: theme.palette.border,
    borderRadius: 4,
    zIndex: 0
  },
  button: {
    textTransform: "none",
    minWidth: 160
  },
  scrollButtons: {
    color: theme.palette.secondary.main
  }
}));
const Tabs = ({
  tabLabels,
  activeTab,
  onChange,
  tabButtonWidth
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(AppBar, {
    position: "static",
    classes: {
      root: classes.tabsRoot
    }
  }, /*#__PURE__*/React.createElement(MUITabs, {
    value: activeTab,
    onChange: onChange,
    indicatorColor: "secondary",
    variant: "scrollable",
    scrollButtons: "auto",
    textColor: "secondary",
    classes: {
      scrollButtons: classes.scrollButtons
    }
  }, tabLabels.map((tabLabel, index) => {
    return /*#__PURE__*/React.createElement(Tab, {
      key: index,
      id: tabLabel,
      label: tabLabel,
      classes: {
        root: classes.button
      },
      style: {
        minWidth: tabButtonWidth || 160
      }
    });
  })));
};
export default Tabs;
Tabs.propTypes = {
  tabLabels: PropTypes.array.isRequired,
  activeTab: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  tabButtonWidth: PropTypes.number
};